<div class="inventory-categories-container">
	<div class="content">
		<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
		<ng-template #loadedContent>
			<ng-container *ngIf="userHasAccess; else noAccess">
				<div class="inventory-container">
					<div class="content">
						<ng-container *ngIf="isMobileSize; else desktopSize">
							<app-mobile-inventory-categories-table
								[isLoading]="categoriesLoading"
								[categoryItems]="inventoryCategories"
								[showArchived$]="showArchived$"
								(inventoryCategoryEdit)="onInventoryCategoryEdit($event)"
								(inventoryCategoryArchive)="onInventoryCategoryArchive($event)"
								(inventoryCategoryUnarchive)="onInventoryCategoryUnarchive($event)"
								(addNewEvent)="openAddInventoryCategoryOffcanvas()"
							></app-mobile-inventory-categories-table>
						</ng-container>
						<ng-template #desktopSize>
							<app-desktop-inventory-categories-table
								[isLoading]="categoriesLoading"
								[categoryItems]="inventoryCategories"
								[showArchived$]="showArchived$"
								(inventoryCategoryEdit)="onInventoryCategoryEdit($event)"
								(inventoryCategoryArchive)="onInventoryCategoryArchive($event)"
								(inventoryCategoryUnarchive)="onInventoryCategoryUnarchive($event)"
								(addNewEvent)="openAddInventoryCategoryOffcanvas()"
							></app-desktop-inventory-categories-table>
						</ng-template>
					</div>
				</div>
			</ng-container>

			<ng-template #noAccess>
				<app-unauthorised-banner
					headingText="It looks like you do not have access to this organisation or do not have the required access level."
				></app-unauthorised-banner>
			</ng-template>
		</ng-template>
	</div>
</div>
